<div class="d-flex flex-row align-items-center unsaved-changes-header dialog-gap fw-bold">
  <i class="pi pi-save fs-4"></i>
  <h5 class="m-0">{{ headerText }}</h5>
</div>
<div class="message mt-3" [innerHTML]="message"></div>
<div class="dialog-button-container">
  <button pButton severity="secondary" type="button" (click)="continueWithoutSaving()">{{ cancelButtonText }}</button>
  <button pButton type="button" (click)="saveAndContinue()">{{ saveButtonText }}</button>
</div>
